import type { GeneratedStory, CreateGeneratedStory } from 'schemas';
import { CreateGeneratedStoryResponseSchema } from 'schemas';
import { apiRequest } from '@/api/helpers/apiRequest';
import { handleApiError } from '@/api/helpers/handleApiError';

export const createGeneratedStory = async (
  data: CreateGeneratedStory
): Promise<{ message: string; story: GeneratedStory }> => {
  try {
    return await apiRequest(
      'POST',
      '/api/generated-stories',
      data,
      CreateGeneratedStoryResponseSchema
    );
  } catch (error) {
    handleApiError(error);
  }
};
